var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notesview"}},[_c('notes',{attrs:{"notes":_vm.notes}}),_c('create-note',{on:{"create-note":_vm.createNote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }